Customer.Views ||= {}
Customer.Views.Insights ||= {}

class Customer.Views.Insights.ActivityResultsView extends Backbone.View
  template: JST["backbone/templates/customer/insights/activity_results"]

  initialize: (@options = {}) ->

  render: (options = {}) ->
    $('#activity-results').html @template(@options)
    @
